import Box from '../Box';
import {ScrollView} from 'react-native-gesture-handler';
import Feather from 'react-native-vector-icons/Feather';
import CCText from '../CCText';
import Spacer from '../Spacer';
import CCColors, {updateColorWithOpacity} from '@/Utils/CCColors';
import {FontSizes, WINDOW_HEIGHT} from '@/Utils/Dimensions';
import Entypo from 'react-native-vector-icons/Entypo';
import ConditionalRender from '../ConditionalRender';
import customStyles from './styles';
import React, {useEffect, useRef, useState} from 'react';
import StockfishEngine from '@/Components/StockfishEngine';
import {
  ActivityIndicator,
  Switch,
  TouchableOpacity,
  View,
  Image,
  Platform,
} from 'react-native';
import StockfishComponent from '@/Components/StockfishEngine/StockfishComponent';
import Divider from '../Divider/Divider';
import {throttle} from 'lodash';
import ContextMenu from '@/Components/ContextMenu';
import usePromoteBranch, {
  PromoteBranchPayload,
} from '@/Hooks/ManageMoves/useManageMoves';
import {moveAnnotationsObjToDisplay} from '@/Utils/CommonUtils';
import Tooltip from '@/Atoms/Tooltip';

interface movesListProps {
  gameMoves: any[]; // Update the type to match your data structure
  activeMove: any; // Update the type to match your data structure
  handleChessMove: (move: any, arg1: boolean, arg2: string, arg3: any) => void; // Update the argument types and return type as needed
  handleAddAnnotation: (move: any) => void; // Update the argument type as needed
  convertToStandardEval: any; // Update the argument types and return type as needed
  evaluateMove: (move: any) => string; // Update the argument type and return type as needed
  //   customStyles?: any;
  moveIconsAndColors?: any; // Update the type to match your move icons and colors object
  moveCoords?: any[]; // Update the type to match your moveCoords data structure
  setClicked: React.Dispatch<React.SetStateAction<any>>; // Update the state type as needed
  setmoveSelected: React.Dispatch<React.SetStateAction<any>>; // Update the state type as needed
  useFeather: boolean;
  playerOneColor: any;
  playerTwoColor: any;
  main: boolean;
  fen2: any;
  isFenFromOutside?: boolean;
  setIsFenFromOutside?: () => {};
  disableArrowMove?: boolean;
  descriptionText?: string;
  gameScoreDetails?: any | null;
  /** Model / PGN-only games: no clock or engine eval columns */
  hideClockAndEval?: boolean;
  redesignedReview?: boolean;
  isMoveListLoading?: boolean;
}

/** Opening principle chips + popovers (white card, ring + check / ring + X) */
const OPENING_PRINCIPLE_UI = {
  followRing: '#3DAB9E',
  violationRing: CCColors.Gradient.LightRed,
  textPrimary: '#262322',
  badgeSize: 24,
  rowIconSize: 18,
} as const;

const openingPrinciplePopoverShadow =
  Platform.OS === 'web'
    ? ({
        boxShadow: '0px 4px 24px rgba(38, 35, 34, 0.12)',
      } as const)
    : {
        shadowColor: '#262322',
        shadowOffset: {width: 0, height: 4},
        shadowOpacity: 0.12,
        shadowRadius: 12,
        elevation: 8,
      };

// const displayChildMove = (
//   move,
//   depth = 0,
//   branchNumber = 1,
//   onMoveClick = () => {},
// ) => {
//   // Construct the move button with indentation, depth, and numbering
//   const indentation = ' '.repeat(depth * 2); // Adjust the multiplication factor to control spacing
//   const moveLabel = `${branchNumber}. ${move.san}`;

//   // Define what happens when a move is clicked
//   const handleMoveClick = () => {
//     console.log(`Move clicked: ${move.san}`);
//     onMoveClick(move);
//   };

//   // Create a button for each move
//   return (
//     <CCButton key={move.id} onPress={handleMoveClick} style={{marginLeft: depth * 10, padding: 8, marginVertical: 4}}>
//       {indentation}{moveLabel}
//     </CCButton>
//   );
// };

const MovesList: React.FC<movesListProps> = ({
  gameMoves,
  setGameMoves,
  activeMove,
  handleChessMove = () => {},
  handleAddAnnotation = () => {},
  convertToStandardEval = () => {},
  evaluateMove = () => {},
  refetchStudy = () => {},
  descriptionText,
  //   customStyles,
  //   FontSizes,
  moveIconsAndColors,
  moveCoords,
  setClicked,
  setLoading = () => {},
  setmoveSelected,
  useFeather = false,
  playerOneColor = undefined,
  playerTwoColor = undefined,
  main = false,
  fen2,
  isFenFromOutside = false,
  setIsFenFromOutside = () => {},
  disableArrowMove = false,
  gameScoreDetails,
  hideClockAndEval = false,
  redesignedReview = false,
  isMoveListLoading = false,
}) => {
  const evalPerspectiveWhiteOnBottom =
    (gameMoves?.[0]?.player === 'me' && gameMoves?.[0]?.color === 'white') ||
    (gameMoves?.[2]?.player === 'me' && gameMoves?.[2]?.color === 'white');

  const formatMoveClock = (move: any) => {
    if (hideClockAndEval) {
      return '';
    }
    const sec = move?.time_left_on_clock;
    if (sec == null || sec === '') {
      return '';
    }
    const n = Number(sec);
    if (!Number.isFinite(n)) {
      return '';
    }
    const m = Math.floor(n / 60);
    const s = Math.floor(n % 60);
    return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  };

  const formatMoveEval = (move: any) => {
    if (hideClockAndEval || !convertToStandardEval) {
      return null;
    }
    const sc = move?.score;
    if (sc == null || sc === '' || !Number.isFinite(Number(sc))) {
      return null;
    }
    const out = convertToStandardEval(evalPerspectiveWhiteOnBottom, sc);
    if (out == null) {
      return null;
    }
    if (typeof out === 'number' && Number.isNaN(out)) {
      return null;
    }
    const str = String(out);
    if (str === 'NaN' || str.includes('NaN')) {
      return null;
    }
    return out;
  };

  const renderOpeningPrincipleIcons = (move: any) => {
    const insights = Array.isArray(move?.opening_principle_insights)
      ? move.opening_principle_insights
      : [];
    if (insights.length === 0) {
      return null;
    }

    const dedupeByPrincipleKey = (items: any[]) => {
      const seen = new Set<string>();
      return items.filter(i => {
        const k = String(i?.principle ?? '')
          .trim()
          .toLowerCase();
        if (!k || seen.has(k)) {
          return false;
        }
        seen.add(k);
        return true;
      });
    };

    const violated = dedupeByPrincipleKey(
      insights.filter(i => i?.outcome === 'violated' && i?.principle),
    );
    const followed = dedupeByPrincipleKey(
      insights.filter(i => i?.outcome === 'followed' && i?.principle),
    );

    if (violated.length === 0 && followed.length === 0) {
      return null;
    }

    const principleNameOnly = (i: any) =>
      String(i?.principle || '')
        .replace(/_/g, ' ')
        .trim();

    /** List rows in popover: outlined circle, white interior, check / X (design reference). */
    const principleListIcon = (
      variant: 'followed' | 'violated',
      size: number,
    ) => {
      const accent =
        variant === 'followed'
          ? OPENING_PRINCIPLE_UI.followRing
          : OPENING_PRINCIPLE_UI.violationRing;
      const glyphSize = Math.round(size * 0.55);
      return (
        <View
          style={{
            width: size,
            height: size,
            borderRadius: size / 2,
            borderWidth: 2,
            borderColor: accent,
            backgroundColor: '#FFFFFF',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          {variant === 'followed' ? (
            <Feather name="check" size={glyphSize} color={accent} />
          ) : (
            <Feather name="x" size={glyphSize} color={accent} />
          )}
        </View>
      );
    };

    /** Compact chip next to the move: solid ring color, white “O” center (Figma move badge). */
    const principleChipIcon = (
      variant: 'followed' | 'violated',
      size: number,
    ) => {
      const accent =
        variant === 'followed'
          ? OPENING_PRINCIPLE_UI.followRing
          : OPENING_PRINCIPLE_UI.violationRing;
      return (
        <View
          style={{
            width: size,
            height: size,
            borderRadius: size / 2,
            backgroundColor: accent,
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <CCText
            style={{
              color: '#FFFFFF',
              fontSize: Math.round(size * 0.42),
              fontWeight: '900',
              lineHeight: Math.round(size * 0.9),
            }}>
            O
          </CCText>
        </View>
      );
    };

    const principleBadge = (
      variant: 'followed' | 'violated',
      onToggle: () => void,
      withLeadingGap: boolean,
    ) => (
      <TouchableOpacity
        onPress={onToggle}
        activeOpacity={0.75}
        style={{
          marginLeft: withLeadingGap ? 4 : 0,
        }}>
        {principleChipIcon(variant, OPENING_PRINCIPLE_UI.badgeSize)}
      </TouchableOpacity>
    );

    const followedBody =
      followed.length > 0 ? (
        <View>
          <CCText
            style={{
              fontSize: 14,
              fontWeight: '700',
              color: OPENING_PRINCIPLE_UI.textPrimary,
              marginBottom: 12,
            }}>
            Opening Principle Followed
          </CCText>
          {followed.map((i, idx) => (
            <View
              key={`f-${String(i.principle)}-${idx}`}
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: idx === followed.length - 1 ? 0 : 10,
              }}>
              {principleListIcon('followed', OPENING_PRINCIPLE_UI.rowIconSize)}
              <CCText
                style={{
                  flex: 1,
                  marginLeft: 10,
                  fontSize: 13,
                  color: OPENING_PRINCIPLE_UI.textPrimary,
                  lineHeight: 18,
                }}>
                {principleNameOnly(i)}
              </CCText>
            </View>
          ))}
        </View>
      ) : null;

    const violatedBody =
      violated.length > 0 ? (
        <View>
          <CCText
            style={{
              fontSize: 14,
              fontWeight: '700',
              color: OPENING_PRINCIPLE_UI.textPrimary,
              marginBottom: 12,
            }}>
            Opening Principle Violated
          </CCText>
          {violated.map((i, idx) => (
            <View
              key={`v-${String(i.principle)}-${idx}`}
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: idx === violated.length - 1 ? 0 : 10,
              }}>
              {principleListIcon('violated', OPENING_PRINCIPLE_UI.rowIconSize)}
              <CCText
                style={{
                  flex: 1,
                  marginLeft: 10,
                  fontSize: 13,
                  color: OPENING_PRINCIPLE_UI.textPrimary,
                  lineHeight: 18,
                }}>
                {principleNameOnly(i)}
              </CCText>
            </View>
          ))}
        </View>
      ) : null;

    const popoverShared = {
      position: 'top' as const,
      backgroundColor: '#FFFFFF',
      borderColor: 'rgba(38, 35, 34, 0.08)',
      borderWidth: 1,
      arrowColor: '#FFFFFF',
      width: 280,
      paddingVertical: 14,
      contentStyle: openingPrinciplePopoverShadow,
    };

    return (
      <Box flexDirection="row" alignItems="center" style={{marginLeft: 6}}>
        {followed.length > 0 && (
          <Tooltip text="" body={followedBody} {...popoverShared}>
            {toggle => principleBadge('followed', toggle, false)}
          </Tooltip>
        )}
        {violated.length > 0 && (
          <Tooltip text="" body={violatedBody} {...popoverShared}>
            {toggle => principleBadge('violated', toggle, followed.length > 0)}
          </Tooltip>
        )}
      </Box>
    );
  };

  function isWhitesTurn(fen) {
    // Split the FEN string by spaces
    const fenParts = fen.split(' ');

    // The second part of the FEN string indicates the active color
    const activeColor = fenParts[1];

    // Return true if the active color is 'w', otherwise false
    return activeColor === 'w';
  }

  console.log('gameMoves0: ', gameMoves?.[0]);
  if (
    gameMoves?.[0] &&
    gameMoves?.[0]?.fen &&
    isWhitesTurn(gameMoves?.[0]?.fen)
  ) {
    gameMoves?.unshift({});
  }
  console.log('gameMoves: ', gameMoves);
  const [indexSelected, setIndexSelected] = useState(0);
  const [stockfishHeight, setStockfishHeight] = useState(0);
  const windowHeight = WINDOW_HEIGHT - 0.15 * WINDOW_HEIGHT;
  const {
    mutate: manageBranch,
    isLoading,
    data: promotoSuccessData,
  } = usePromoteBranch();

  useEffect(() => {
    if (isLoading !== undefined) {
      setLoading(isLoading);
    }
  }, [isLoading]);

  const handleMove = throttle((moveType: 'next' | 'prev') => {
    // setSelectedTab('GAME REVIEW');

    // switch (moveType) {
    //   case 'next':
    switch (moveType) {
      case 'next':
        handleMoveSelect(indexSelected + 1);
        // console.log(activeMove, 'activeMove');
        break;
      case 'prev':
        handleMoveSelect(indexSelected - 1);
        // console.log(activeMove, 'activeMove');
        break;

      default:
        break;
    }
  }, 300);

  useEffect(() => {
    const handleKeyDown = event => {
      if (disableArrowMove) return;
      if (event.keyCode === 37) {
        handleMove('prev');
      } else if (event.keyCode === 39) {
        handleMove('next');
      }
    };

    // Attach the event listener
    if (!disableArrowMove) {
      window.addEventListener('keydown', handleKeyDown);
    }

    // Clean up the event listener
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleMove]);

  useEffect(() => {
    if (promotoSuccessData) {
      refetchStudy();
    }
  }, [promotoSuccessData]);

  const handleBranchPromotion = (tempPayload: PromoteBranchPayload) => {
    manageBranch(tempPayload);
  };

  const displayChildMove = (
    move,
    currentLine = '',
    depth = 0,
    branchNumber = 1,
    prevMove = null,
    onMoveClick = () => {},
    parentIndex,
  ) => {
    // Append the current move to the line
    const isSelected = activeMove?.id === move?.id;
    console.log(move, 'displayChildMove');
    let moveDescription = (
      <CCText
        {...(isSelected ? {fontWeight: 'semibold'} : {})}
        style={isSelected ? {color: CCColors?.Primary?.Default} : {}}
        onPress={() => {
          // debugger;
          onMoveClick?.(move, prevMove);
        }}>
        {`${
          depth % 2 === 0 ? ` ${parentIndex + Math.floor(depth / 2)}.` : ''
        } ${move.san}`}
        {move?.annotation && (
          <CCText color={CCColors?.Grey.Grey} fontSize={FontSizes[11]}>
            <Spacer spacing={5} horizontal />
            {move?.annotation}
          </CCText>
          // <Entypo
          //   name="dot-single"
          //   size={25}
          //   color={updateColorWithOpacity(CCColors?.Red, 0.7)}
          //   style={{
          //     position: 'absolute',
          //     right: '-51%',
          //     top: '-69%',
          //   }}
          // />
        )}
      </CCText>
    );

    if (move?.child_moves?.length === 0) {
      moveDescription = (
        <ContextMenu
          menuOptions={[
            {
              label: 'Promote',
              onClick: () => {
                handleBranchPromotion({action: 'promote', move_id: move?.id});
              },
            },
            {
              label: 'Delete',
              onClick: () => {
                handleBranchPromotion({action: 'delete', move_id: move?.id});
              },
            },
          ]}>
          {moveDescription}
        </ContextMenu>
      );
    }
    const newLine =
      depth === 0 ? (
        <>
          {/* <CCText>...</CCText> */}
          {/* {branchNumber}. */}
          {/* {moveDescription} */}
        </>
      ) : (
        <>
          {currentLine}
          {moveDescription}
        </>
      );

    // Define what happens when a move is clicked
    const handleMoveClick = () => {
      onMoveClick?.(move, prevMove);
    };

    // If this move has no children, create a Text element for this complete line
    if (!move.child_moves || move.child_moves.length === 0) {
      return [
        <Box
          key={move.id}
          style={[{fontSize: 16}, customStyles.childSeq]}
          onPress={handleMoveClick}>
          <Divider width={1} style={{width: 20}} color={CCColors.Black} />
          <CCText></CCText>
          {newLine}
        </Box>,
      ];
    } else {
      // Otherwise, continue creating lines for each child move
      return move.child_moves.flatMap((childMove, index) =>
        displayChildMove(
          childMove,
          newLine,
          depth + 1,
          depth === 0 ? branchNumber + index + 1 : branchNumber,
          move, // passing current move as the previous move for the next level
          onMoveClick,
          parentIndex,
        ),
      );
    }
  };
  // onPress={() => {
  //   if (!gameMoves?.[index]) return;
  //   if (isWhiteMoveSelected) {
  //     handleAddAnnotation(gameMoves?.[index]);
  //   }

  //   handleChessMove(
  //     gameMoves?.[index],
  //     false,
  //     '',
  //     gameMoves?.[index - 1],
  //   );
  //   console.log(gameMoves[index]);
  //   setmoveSelected(gameMoves[index]);
  //   setClicked?.(true);
  //   setIsFenFromOutside(false);
  // }}
  const handleMoveSelect = tempIndex => {
    // const isWhiteMoveSelected = activeMove?.id
    //   ? activeMove?.id === gameMoves?.[tempIndex]?.id
    //   : activeMove?.fen === gameMoves?.[tempIndex]?.fen;

    // const isBlackMoveSelected = activeMove?.id
    //   ? activeMove?.id === gameMoves?.[tempIndex + 1]?.id
    //   : activeMove?.fen === gameMoves?.[tempIndex + 1]?.fen;
    if (!gameMoves?.[tempIndex]) return;
    // if (isWhiteMoveSelected) {
    // handleAddAnnotation(gameMoves?.[tempIndex]);
    // }

    handleChessMove(
      gameMoves?.[tempIndex],
      false,
      '',
      gameMoves?.[tempIndex - 1],
    );
    setmoveSelected?.(gameMoves?.[tempIndex]);
    setClicked?.(true);
    setIsFenFromOutside(false);
    setIndexSelected(tempIndex);
  };
  const scrollViewRef = useRef();

  const scrollToBottom = () => {
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollToEnd({animated: true});
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [gameMoves]);

  const reviewMoves = Array.isArray(gameMoves)
    ? gameMoves
        .map((move, originalIndex) =>
          move ? {...move, __reviewOriginalIndex: originalIndex} : move,
        )
        .filter(move => move && (move.move || move.san || move.fen))
    : [];

  const getMoveLabel = (move: any) =>
    String(move?.move || move?.san || '').trim();

  const isMoveSelected = (move: any) => {
    if (!move) {
      return false;
    }
    if (activeMove?.id && move?.id) {
      return activeMove.id === move.id;
    }
    return Boolean(activeMove?.fen && move?.fen && activeMove.fen === move.fen);
  };

  const getReviewRows = () => {
    const rows: any[] = [];
    reviewMoves.forEach((move, reviewIndex) => {
      const moveNumber = Number(move?.move_index);
      const rowIndex =
        Number.isFinite(moveNumber) && moveNumber > 0
          ? moveNumber - 1
          : Math.floor(reviewIndex / 2);

      if (!rows[rowIndex]) {
        rows[rowIndex] = {moveNumber: rowIndex + 1, white: null, black: null};
      }

      if (move?.color === 'black') {
        rows[rowIndex].black = move;
      } else if (move?.color === 'white') {
        rows[rowIndex].white = move;
      } else if (reviewIndex % 2 === 0) {
        rows[rowIndex].white = move;
      } else {
        rows[rowIndex].black = move;
      }
    });
    return rows.filter(Boolean);
  };

  const getMoveQuality = (move: any) => {
    const key = evaluateMove?.(move);
    if (!key) {
      return null;
    }
    const semanticColor =
      key === 'Blunder'
        ? '#E17846'
        : key === 'Mistake'
        ? '#D1AB41'
        : key === 'Inaccuracy'
        ? '#67B3E1'
        : key === 'PrincipleViolation'
        ? '#dc2626'
        : moveIconsAndColors?.[key]?.color;
    return {
      ...moveIconsAndColors?.[key],
      color: semanticColor,
    };
  };

  const renderReviewMoveCell = (move: any) => {
    if (!move) {
      return <View style={customStyles.reviewEmptyCell} />;
    }

    const originalIndex = move.__reviewOriginalIndex;
    const moveLabel = getMoveLabel(move);
    const clock = formatMoveClock(move);
    const moveEval = formatMoveEval(move);
    const quality = getMoveQuality(move);
    const selected = isMoveSelected(move);
    const flagged = Boolean(quality?.icon);
    const qualityColor = quality?.color || '#CD2C39';

    return (
      <TouchableOpacity
        activeOpacity={0.82}
        onPress={() => handleMoveSelect(originalIndex)}
        style={[
          customStyles.reviewMoveCell,
          selected && customStyles.reviewMoveCellSelected,
        ]}>
        <View style={customStyles.reviewMoveTopLine}>
          <View style={customStyles.reviewMoveLeft}>
            <CCText
              style={[
                customStyles.reviewMoveSan,
                flagged && {color: qualityColor},
              ]}>
              {moveLabel || '-'}
            </CCText>
            {quality?.icon && (
              <View style={customStyles.reviewQualityIcon}>
                {typeof quality.icon === 'string' ? (
                  <CCText
                    style={[
                      customStyles.reviewBadgeText,
                      {color: qualityColor},
                    ]}>
                    {quality.icon}
                  </CCText>
                ) : (
                  quality.icon
                )}
              </View>
            )}
            {renderOpeningPrincipleIcons(move)}
          </View>
          {useFeather && selected && (
            <Feather
              name="edit-3"
              size={13}
              color="#8F7A65"
              onPress={() => handleAddAnnotation?.(move)}
            />
          )}
        </View>
        {(clock || moveEval !== null) && (
          <View style={customStyles.reviewMoveMeta}>
            {clock ? (
              <CCText style={customStyles.reviewMoveClock}>{clock}</CCText>
            ) : null}
            {moveEval !== null ? (
              <CCText style={customStyles.reviewMoveEval}>{moveEval}</CCText>
            ) : null}
          </View>
        )}
      </TouchableOpacity>
    );
  };

  const renderRedesignedReviewList = () => (
    <ScrollView
      style={customStyles.reviewListScroll}
      showsVerticalScrollIndicator={false}
      ref={scrollViewRef}>
      {isMoveListLoading && reviewMoves.length === 0 ? (
        <View style={customStyles.reviewMoveListLoader}>
          <ActivityIndicator size="small" color={CCColors.Green} />
          <CCText style={customStyles.reviewMoveListLoaderText}>
            Loading moves...
          </CCText>
        </View>
      ) : reviewMoves.length === 0 ? (
        <CCText textAlign="center">No moves available</CCText>
      ) : (
        <View style={customStyles.reviewListContainer}>
          <View style={customStyles.reviewHeaderRow}>
            <CCText style={customStyles.reviewHeaderNo}>#</CCText>
            <CCText style={customStyles.reviewHeaderCell}>White</CCText>
            <CCText style={customStyles.reviewHeaderCell}>Black</CCText>
          </View>
          <View style={customStyles.reviewRows}>
            {getReviewRows().map(row => (
              <View
                key={`review-row-${row.moveNumber}`}
                style={customStyles.reviewRow}>
                <CCText style={customStyles.reviewMoveNo}>
                  {row.moveNumber}
                </CCText>
                {renderReviewMoveCell(row.white)}
                {renderReviewMoveCell(row.black)}
              </View>
            ))}
          </View>
        </View>
      )}
    </ScrollView>
  );

  return (
    <View style={customStyles?.playerScore}>
      <View
        onLayout={event => {
          setStockfishHeight(event.nativeEvent.layout.height);
        }}>
        <StockfishComponent
          fen={isFenFromOutside ? fen2 : activeMove?.fen}
          count={activeMove?.move_index}
          gameScoreDetails={gameScoreDetails}
          reviewVariant={redesignedReview}
        />
      </View>
      {descriptionText && (
        <Box
          style={{
            paddingVertical: 10,
            paddingHorizontal: 15,
          }}>
          <CCText fontWeight="regular" fontSize={14}>
            {descriptionText}
          </CCText>
        </Box>
      )}

      {redesignedReview && renderRedesignedReviewList()}
      {!redesignedReview && (
        <ScrollView
          style={{height: windowHeight - stockfishHeight}}
          // ref={ref => setMovesScrollView(ref)}
          showsVerticalScrollIndicator={false}
          ref={scrollViewRef}
          //  style={customStyles?.playerScore}
        >
          {/* <Switch
        trackColor={{false: '#767577', true: '#81b0ff'}}
        thumbColor={enableStockfish ? '#f5dd4b' : '#f4f3f4'}
        ios_backgroundColor="#3e3e3e"
        onValueChange={() => setEnableStockfish(!enableStockfish)}
        value={enableStockfish}
      /> */}
          {/*
      <StockfishEngine
        fen={activeMove?.fen}
        depth={10}
        variations={3}
        // engineOn={enableStockfish}
        onResult={handleStockfishResult}
      /> */}
          {/* {Object.entries(moveSequences)?.map(([variationNumber, moves]) => (
        <Box key={variationNumber}>
          <CCText>Variation {variationNumber}:</CCText>
          <Box type="row-flex-start" style={{flexWrap: 'wrap'}}>
            {moves?.map((move, index) => (
              <>
                <CCText key={index}>{move}</CCText>
                <Spacer spacing={5} horizontal />
              </>
            ))}
          </Box>
        </Box>
      ))} */}
          {gameMoves?.length === 0 && (
            <CCText textAlign="center">No moves available</CCText>
          )}
          {gameMoves?.map((move, index) => {
            // Only work on even indexes to get alternate values
            let isColorMatched;
            if (playerOneColor && playerTwoColor) {
              isColorMatched = playerOneColor === playerTwoColor ? 1 : 0;
            } else {
              isColorMatched = 0;
            }
            const isWhiteMoveSelected = activeMove?.id
              ? activeMove?.id === gameMoves?.[index]?.id
              : activeMove?.fen === gameMoves?.[index]?.fen;

            const isBlackMoveSelected = activeMove?.id
              ? activeMove?.id === gameMoves?.[index + 1]?.id
              : activeMove?.fen === gameMoves?.[index + 1]?.fen;

            if (index % 2 === isColorMatched) {
              let returnDiv = [];
              if (
                gameMoves?.[index]?.annotation ||
                gameMoves?.[index]?.child_moves?.length > 0
              ) {
                returnDiv.push(
                  <>
                    <Box
                      key={index}
                      onLayout={e => {
                        if (moveCoords) {
                          moveCoords[index / 2] = e.nativeEvent.layout.y;
                        }
                      }}
                      flexDirection="row"
                      alignItems="flex-start"
                      justifyContent="space-between">
                      <Box
                        flexDirection="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        flex={0.1}
                        style={{width: '100%', padding: 15}}>
                        <CCText
                          style={{
                            fontWeight: 'bold',
                            textAlign: 'right',
                            width: '100%',
                          }}>
                          {Math.floor(index / 2 + 1)}.
                        </CCText>
                      </Box>
                      <Box
                        style={[
                          isWhiteMoveSelected
                            ? customStyles?.selectedMove
                            : index === 0 ||
                              (playerOneColor === playerTwoColor && index === 1)
                            ? customStyles.eachMoveWrapper1
                            : customStyles.eachMoveWrapper,
                          {
                            height: '100%',
                          },
                        ]}
                        flex={0.46}>
                        <Box
                          flexDirection="row"
                          justifyContent="space-between"
                          style={customStyles.eachMoveInsideWrapper}
                          // flexDirection="row"

                          alignItems="center"
                          onPress={() => handleMoveSelect(index)}
                          flex={1}
                          style={{width: '100%'}}>
                          {/* {isWhiteMoveSelected && (
                          <>
                            {useFeather && (
                              <Feather
                                size={20}
                                name="edit-3"
                                color={CCColors.Primary.Brown}
                                onPress={event => {
                                  handleAddAnnotation(gameMoves?.[index]);
                                  event.stopPropagation();
                                }}
                              />
                            )}
                            <Spacer spacing={5} horizontal />
                          </>
                        )} */}
                          <CCText
                            style={{
                              marginVertical: 15,
                              flex: 0.5,
                              flexDirection: 'row',
                            }}>
                            {gameMoves?.[index]?.move}{' '}
                            {
                              moveIconsAndColors?.[
                                evaluateMove(gameMoves?.[index])
                              ]?.icon
                            }
                            {renderOpeningPrincipleIcons(gameMoves?.[index])}
                            {/* <Entypo
                            name="dot-single"
                            size={25}
                            color={updateColorWithOpacity(CCColors?.Red, 0.7)}
                            style={{
                              position: 'absolute',
                              right: '-8%',
                              top: '-68%',
                            }}
                          /> */}
                          </CCText>{' '}
                          {gameMoves?.[index]?.annotation_icon && (
                            <Box style={customStyles?.annotationIconsWrapper}>
                              <Image
                                resizeMode="contain"
                                style={[customStyles.annotationIcons]}
                                source={
                                  moveAnnotationsObjToDisplay[
                                    gameMoves?.[index]?.annotation_icon
                                  ]?.icon
                                }
                              />
                            </Box>
                          )}
                          {/* {gameMoves?.[index]?.annotation && (
                          <CCText
                            style={{
                              position: 'absolute',
                              right: 0,
                              top: 0,
                              backgroundColor: updateColorWithOpacity(
                                CCColors?.Red,
                                0.7,
                              ),
                              borderBottomLeftRadius: 5,
                              borderBottomRightRadius: 5,
                              padding: 2,
                              color: CCColors.White,
                            }}>
                            note
                          </CCText>
                        )} */}
                          <CCText
                            style={{
                              textAlign: 'center',
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginVertical: 15,
                              fontSize: FontSizes[10],
                              color: CCColors.TextColor.Grey,
                              flex: 0.5,
                            }}>
                            {formatMoveClock(gameMoves?.[index])}
                          </CCText>
                          <CCText
                            style={{
                              textAlign: 'right',
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginVertical: 15,
                              fontSize: FontSizes[10],
                              color: CCColors.TextColor.Grey,
                              flex: 0.5,
                            }}>
                            {formatMoveEval(gameMoves?.[index])}
                          </CCText>
                        </Box>
                      </Box>
                      <Box
                        flex={0.46}
                        style={[
                          false
                            ? customStyles?.selectedMove
                            : index === 0 ||
                              (playerOneColor === playerTwoColor && index === 1)
                            ? customStyles.eachMoveWrapper2
                            : customStyles.eachMoveWrapper,
                          {
                            height: '100%',
                          },
                        ]}>
                        <Box
                          flexDirection="row"
                          justifyContent="flex-start"
                          // flexDirection="row"
                          style={customStyles.eachMoveInsideWrapper}
                          alignItems="center"
                          // onPress={() => handleMoveSelect(index + 1)}
                          // onPress={() => {
                          //   if (!gameMoves?.[index + 1]) return;
                          //   setIndexSelected(index + 1);
                          //   if (isBlackMoveSelected) {
                          //     handleAddAnnotation(gameMoves?.[index + 1]);
                          //   }
                          //   handleChessMove(
                          //     gameMoves?.[index + 1],
                          //     false,
                          //     '',
                          //     gameMoves?.[index],
                          //   );
                          //   if (main) {
                          //     console.log(gameMoves[index]);
                          //     setmoveSelected(gameMoves[index]);
                          //   } else {
                          //     console.log(gameMoves[index + 1]);
                          //     setmoveSelected(gameMoves[index + 1]);
                          //   }

                          //   setClicked?.(true);
                          //   setIsFenFromOutside(false);
                          // }}
                          flex={1}
                          style={{width: '100%'}}>
                          {isBlackMoveSelected && (
                            <ConditionalRender
                              condition={useFeather}
                              childrenA={
                                <>
                                  <Feather
                                    size={20}
                                    name="edit-3"
                                    color={CCColors.Primary.Brown}
                                    onPress={event => {
                                      handleAddAnnotation(
                                        gameMoves?.[index + 1],
                                      );
                                      event.stopPropagation();
                                    }}
                                  />
                                  <Spacer spacing={5} horizontal />
                                </>
                              }
                            />
                          )}
                          <CCText
                            style={[
                              // activeMove?.fen ===
                              // gameMoves?.[index + 1]?.fen
                              //   ? customStyles?.selectedMove
                              //   : customStyles?.playerScoreEach,
                              {
                                width: '100%',
                                textAlign: 'left',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginVertical: 15,
                                flex: 0.5,
                              },
                            ]}>
                            ...
                            {/* {gameMoves?.[index + 1]?.move}{' '}
                          {
                            moveIconsAndColors?.[
                              evaluateMove(gameMoves?.[index + 1])
                            ]?.icon
                          } */}
                          </CCText>
                          {/* {gameMoves?.[index + 1]?.annotation && (
                          <CCText
                            style={{
                              position: 'absolute',
                              right: 0,
                              top: 0,
                              backgroundColor: updateColorWithOpacity(
                                CCColors?.Red,
                                0.7,
                              ),
                              borderBottomLeftRadius: 5,
                              borderBottomRightRadius: 5,
                              padding: 2,
                              color: CCColors.White,
                            }}>
                            note
                          </CCText>
                        )} */}
                          <CCText
                            style={{
                              textAlign: 'center',
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginVertical: 15,
                              fontSize: FontSizes[10],
                              color: CCColors.TextColor.Grey,
                              flex: 0.5,
                            }}>
                            {formatMoveClock(gameMoves?.[index + 1])}
                          </CCText>
                          <CCText
                            style={{
                              textAlign: 'right',
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginVertical: 15,
                              fontSize: FontSizes[10],
                              color: CCColors.TextColor.Grey,
                              flex: 0.5,
                            }}>
                            {formatMoveEval(gameMoves?.[index + 1])}
                          </CCText>
                        </Box>
                      </Box>
                    </Box>
                    <Box marginLeft={'15%'}>
                      <CCText
                        color={CCColors?.Grey.Grey}
                        fontSize={FontSizes[11]}>
                        {gameMoves?.[index]?.annotation &&
                          `${gameMoves?.[index]?.annotation} (${gameMoves?.[index]?.move})`}
                      </CCText>
                      {/* <CCText
                      color={CCColors?.Grey.Grey}
                      fontSize={FontSizes[11]}>
                      {gameMoves?.[index + 1]?.annotation &&
                        `${gameMoves?.[index + 1]?.annotation} (${
                          gameMoves?.[index + 1]?.move
                        })`}
                    </CCText> */}

                      {gameMoves?.[index]?.child_moves?.length > 0 &&
                        displayChildMove(
                          gameMoves?.[index],
                          '',
                          0,
                          1,
                          null,
                          (currMove, lastMove) => {
                            handleChessMove(currMove, false, '', lastMove);

                            setmoveSelected?.({
                              ...currMove,
                              newFen: currMove?.fen,
                              lastFen: lastMove?.fen,
                              move: currMove?.san,
                            });
                            setIsFenFromOutside(false);
                          },
                          Math.floor(index / 2 + 1),
                        )}
                      {/* {gameMoves?.[index + 1]?.child_moves?.length > 0 &&
                      displayChildMove(
                        gameMoves?.[index + 1],
                        '',
                        0,
                        1,
                        null,
                        (currMove, lastMove) => {
                          handleChessMove(currMove, false, '', lastMove);

                          setmoveSelected?.({
                            ...currMove,
                            newFen: currMove?.fen,
                            lastFen: lastMove?.fen,
                            move: currMove?.san,
                          });

                          setIsFenFromOutside(false);
                        },
                        Math.floor(index / 2 + 1),
                      )} */}
                    </Box>
                    {/* {(gameMoves?.[index + 1]?.annotation ||
                  gameMoves?.[index]?.annotation) && (
                  <>
                    <Spacer spacing={10} />
                    <CCText>Notes</CCText>
                    {gameMoves?.[index]?.annotation}
                    {gameMoves?.[index + 1]?.annotation}
                  </>
                )} */}
                  </>,
                );

                returnDiv.push(
                  <>
                    <Box
                      key={index}
                      onLayout={e => {
                        if (moveCoords) {
                          moveCoords[index / 2] = e.nativeEvent.layout.y;
                        }
                      }}
                      flexDirection="row"
                      alignItems="flex-start"
                      justifyContent="space-between">
                      <Box
                        flexDirection="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        flex={0.1}
                        style={{width: '100%', padding: 15}}>
                        <CCText
                          style={{
                            fontWeight: 'bold',
                            textAlign: 'right',
                            width: '100%',
                          }}>
                          {Math.floor(index / 2 + 1)}.
                        </CCText>
                      </Box>
                      <Box
                        style={[
                          false
                            ? customStyles?.selectedMove
                            : index === 0 ||
                              (playerOneColor === playerTwoColor && index === 1)
                            ? customStyles.eachMoveWrapper1
                            : customStyles.eachMoveWrapper,
                          {
                            height: '100%',
                          },
                        ]}
                        flex={0.46}>
                        <Box
                          flexDirection="row"
                          justifyContent="space-between"
                          style={customStyles.eachMoveInsideWrapper}
                          // flexDirection="row"

                          alignItems="center"
                          // onPress={() => handleMoveSelect(index)}
                          flex={1}
                          style={{width: '100%'}}>
                          {isWhiteMoveSelected && (
                            <>
                              {useFeather && (
                                <Feather
                                  size={20}
                                  name="edit-3"
                                  color={CCColors.Primary.Brown}
                                  onPress={event => {
                                    handleAddAnnotation(gameMoves?.[index]);
                                    event.stopPropagation();
                                  }}
                                />
                              )}
                              <Spacer spacing={5} horizontal />
                            </>
                          )}

                          <CCText
                            style={{
                              marginVertical: 15,
                              flex: 0.5,
                              flexDirection: 'row',
                            }}>
                            ...
                            {/* {gameMoves?.[index]?.move}{' '}
                          {
                            moveIconsAndColors?.[
                              evaluateMove(gameMoves?.[index])
                            ]?.icon
                          } */}
                            {/* <Entypo
                            name="dot-single"
                            size={25}
                            color={updateColorWithOpacity(CCColors?.Red, 0.7)}
                            style={{
                              position: 'absolute',
                              right: '-8%',
                              top: '-68%',
                            }}
                          /> */}
                          </CCText>
                          {/* {gameMoves?.[index]?.annotation && (
                          <CCText
                            style={{
                              position: 'absolute',
                              right: 0,
                              top: 0,
                              backgroundColor: updateColorWithOpacity(
                                CCColors?.Red,
                                0.7,
                              ),
                              borderBottomLeftRadius: 5,
                              borderBottomRightRadius: 5,
                              padding: 2,
                              color: CCColors.White,
                            }}>
                            note
                          </CCText>
                        )} */}

                          <CCText
                            style={{
                              textAlign: 'center',
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginVertical: 15,
                              fontSize: FontSizes[10],
                              color: CCColors.TextColor.Grey,
                              flex: 0.5,
                            }}>
                            {formatMoveClock(gameMoves?.[index])}
                          </CCText>
                          <CCText
                            style={{
                              textAlign: 'right',
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginVertical: 15,
                              fontSize: FontSizes[10],
                              color: CCColors.TextColor.Grey,
                              flex: 0.5,
                            }}>
                            {formatMoveEval(gameMoves?.[index])}
                          </CCText>
                        </Box>
                      </Box>
                      <Box
                        flex={0.46}
                        style={[
                          isBlackMoveSelected
                            ? customStyles?.selectedMove
                            : index === 0 ||
                              (playerOneColor === playerTwoColor && index === 1)
                            ? customStyles.eachMoveWrapper2
                            : customStyles.eachMoveWrapper,
                          {
                            height: '100%',
                          },
                        ]}>
                        <Box
                          flexDirection="row"
                          justifyContent="flex-start"
                          // flexDirection="row"
                          style={customStyles.eachMoveInsideWrapper}
                          alignItems="center"
                          onPress={() => handleMoveSelect(index + 1)}
                          // onPress={() => {
                          //   if (!gameMoves?.[index + 1]) return;
                          //   setIndexSelected(index + 1);
                          //   if (isBlackMoveSelected) {
                          //     handleAddAnnotation(gameMoves?.[index + 1]);
                          //   }
                          //   handleChessMove(
                          //     gameMoves?.[index + 1],
                          //     false,
                          //     '',
                          //     gameMoves?.[index],
                          //   );
                          //   if (main) {
                          //     console.log(gameMoves[index]);
                          //     setmoveSelected(gameMoves[index]);
                          //   } else {
                          //     console.log(gameMoves[index + 1]);
                          //     setmoveSelected(gameMoves[index + 1]);
                          //   }

                          //   setClicked?.(true);
                          //   setIsFenFromOutside(false);
                          // }}
                          flex={1}
                          style={{width: '100%'}}>
                          {isBlackMoveSelected && (
                            <ConditionalRender
                              condition={useFeather}
                              childrenA={
                                <>
                                  <Feather
                                    size={20}
                                    name="edit-3"
                                    color={CCColors.Primary.Brown}
                                    onPress={event => {
                                      handleAddAnnotation(
                                        gameMoves?.[index + 1],
                                      );
                                      event.stopPropagation();
                                    }}
                                  />
                                  <Spacer spacing={5} horizontal />
                                </>
                              }
                            />
                          )}
                          <CCText
                            style={[
                              // activeMove?.fen ===
                              // gameMoves?.[index + 1]?.fen
                              //   ? customStyles?.selectedMove
                              //   : customStyles?.playerScoreEach,
                              {
                                width: '100%',
                                textAlign: 'left',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                // marginVertical: 15,
                                flex: 0.5,
                              },
                            ]}>
                            {gameMoves?.[index + 1]?.move}{' '}
                            {
                              moveIconsAndColors?.[
                                evaluateMove(gameMoves?.[index + 1])
                              ]?.icon
                            }
                            {renderOpeningPrincipleIcons(
                              gameMoves?.[index + 1],
                            )}
                          </CCText>{' '}
                          {gameMoves?.[index + 1]?.annotation_icon && (
                            <Box style={customStyles?.annotationIconsWrapper}>
                              <Image
                                resizeMode="contain"
                                style={[customStyles.annotationIcons]}
                                source={
                                  moveAnnotationsObjToDisplay[
                                    gameMoves?.[index + 1]?.annotation_icon
                                  ]?.icon
                                }
                              />
                            </Box>
                          )}
                          {/* {gameMoves?.[index + 1]?.annotation && (
                          <CCText
                            style={{
                              position: 'absolute',
                              right: 0,
                              top: 0,
                              backgroundColor: updateColorWithOpacity(
                                CCColors?.Red,
                                0.7,
                              ),
                              borderBottomLeftRadius: 5,
                              borderBottomRightRadius: 5,
                              padding: 2,
                              color: CCColors.White,
                            }}>
                            note
                          </CCText>
                        )} */}
                          <CCText
                            style={{
                              textAlign: 'center',
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginVertical: 15,
                              fontSize: FontSizes[10],
                              color: CCColors.TextColor.Grey,
                              flex: 0.5,
                            }}>
                            {formatMoveClock(gameMoves?.[index + 1])}
                          </CCText>
                          <CCText
                            style={{
                              textAlign: 'right',
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginVertical: 15,
                              fontSize: FontSizes[10],
                              color: CCColors.TextColor.Grey,
                              flex: 0.5,
                            }}>
                            {formatMoveEval(gameMoves?.[index + 1])}
                          </CCText>
                        </Box>
                      </Box>
                    </Box>
                    <Box marginLeft={'15%'}>
                      {/* <CCText
                      color={CCColors?.Grey.Grey}
                      fontSize={FontSizes[11]}>
                      {gameMoves?.[index]?.annotation &&
                        `${gameMoves?.[index]?.annotation} (${gameMoves?.[index]?.move})`}
                    </CCText> */}
                      <CCText
                        color={CCColors?.Grey.Grey}
                        fontSize={FontSizes[11]}>
                        {gameMoves?.[index + 1]?.annotation &&
                          `${gameMoves?.[index + 1]?.annotation} (${
                            gameMoves?.[index + 1]?.move
                          })`}
                      </CCText>

                      {/* {gameMoves?.[index]?.child_moves?.length > 0 &&
                      displayChildMove(
                        gameMoves?.[index],
                        '',
                        0,
                        1,
                        null,
                        (currMove, lastMove) => {
                          handleChessMove(currMove, false, '', lastMove);

                          setmoveSelected?.({
                            ...currMove,
                            newFen: currMove?.fen,
                            lastFen: lastMove?.fen,
                            move: currMove?.san,
                          });
                          setIsFenFromOutside(false);
                        },
                        Math.floor(index / 2 + 1),
                      )} */}
                      {gameMoves?.[index + 1]?.child_moves?.length > 0 &&
                        displayChildMove(
                          gameMoves?.[index + 1],
                          '',
                          0,
                          1,
                          null,
                          (currMove, lastMove) => {
                            handleChessMove(currMove, false, '', lastMove);

                            setmoveSelected?.({
                              ...currMove,
                              newFen: currMove?.fen,
                              lastFen: lastMove?.fen,
                              move: currMove?.san,
                            });

                            setIsFenFromOutside(false);
                          },
                          Math.floor(index / 2 + 1),
                        )}
                    </Box>
                    {/* {(gameMoves?.[index + 1]?.annotation ||
                  gameMoves?.[index]?.annotation) && (
                  <>
                    <Spacer spacing={10} />
                    <CCText>Notes</CCText>
                    {gameMoves?.[index]?.annotation}
                    {gameMoves?.[index + 1]?.annotation}
                  </>
                )} */}
                  </>,
                );
              }
              // if (gameMoves?.[index + 1]?.child_moves?.length > 0) {

              // }
              //  {
              else {
                returnDiv.push(
                  <>
                    <Box
                      key={index}
                      onLayout={e => {
                        if (moveCoords) {
                          moveCoords[index / 2] = e.nativeEvent.layout.y;
                        }
                      }}
                      flexDirection="row"
                      alignItems="flex-start"
                      justifyContent="space-between">
                      <Box
                        flexDirection="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        flex={0.1}
                        style={{width: '100%', padding: 15}}>
                        <CCText
                          style={{
                            fontWeight: 'bold',
                            textAlign: 'right',
                            width: '100%',
                          }}>
                          {Math.floor(index / 2 + 1)}.
                        </CCText>
                      </Box>
                      <Box
                        style={[
                          isWhiteMoveSelected
                            ? customStyles?.selectedMove
                            : index === 0 ||
                              (playerOneColor === playerTwoColor && index === 1)
                            ? customStyles.eachMoveWrapper1
                            : customStyles.eachMoveWrapper,
                          {
                            height: '100%',
                          },
                        ]}
                        flex={0.46}>
                        <Box
                          flexDirection="row"
                          justifyContent="space-between"
                          style={customStyles.eachMoveInsideWrapper}
                          // flexDirection="row"

                          alignItems="center"
                          onPress={() => handleMoveSelect(index)}
                          flex={1}
                          style={{width: '100%'}}>
                          {isWhiteMoveSelected && (
                            <>
                              {useFeather && (
                                <Feather
                                  size={20}
                                  name="edit-3"
                                  color={CCColors.Primary.Brown}
                                  onPress={event => {
                                    handleAddAnnotation(gameMoves?.[index]);
                                    event.stopPropagation();
                                  }}
                                />
                              )}
                              <Spacer spacing={5} horizontal />
                            </>
                          )}
                          <CCText
                            style={{
                              marginVertical: 15,
                              flex: 0.5,
                              flexDirection: 'row',
                            }}>
                            {gameMoves?.[index]?.move}{' '}
                            {
                              moveIconsAndColors?.[
                                evaluateMove(gameMoves?.[index])
                              ]?.icon
                            }
                            {renderOpeningPrincipleIcons(gameMoves?.[index])}
                            {/* <Entypo
                          name="dot-single"
                          size={25}
                          color={updateColorWithOpacity(CCColors?.Red, 0.7)}
                          style={{
                            position: 'absolute',
                            right: '-8%',
                            top: '-68%',
                          }}
                        /> */}
                          </CCText>{' '}
                          {gameMoves?.[index]?.annotation_icon && (
                            <Box style={customStyles?.annotationIconsWrapper}>
                              <Image
                                resizeMode="contain"
                                style={[customStyles.annotationIcons]}
                                source={
                                  moveAnnotationsObjToDisplay[
                                    gameMoves?.[index]?.annotation_icon
                                  ]?.icon
                                }
                              />
                            </Box>
                          )}
                          {/* {gameMoves?.[index]?.annotation && (
                        <CCText
                          style={{
                            position: 'absolute',
                            right: 0,
                            top: 0,
                            backgroundColor: updateColorWithOpacity(
                              CCColors?.Red,
                              0.7,
                            ),
                            borderBottomLeftRadius: 5,
                            borderBottomRightRadius: 5,
                            padding: 2,
                            color: CCColors.White,
                          }}>
                          note
                        </CCText>
                      )} */}
                          <CCText
                            style={{
                              textAlign: 'center',
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginVertical: 15,
                              fontSize: FontSizes[10],
                              color: CCColors.TextColor.Grey,
                              flex: 0.5,
                            }}>
                            {formatMoveClock(gameMoves?.[index])}
                          </CCText>
                          <CCText
                            style={{
                              textAlign: 'right',
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginVertical: 15,
                              fontSize: FontSizes[10],
                              color: CCColors.TextColor.Grey,
                              flex: 0.5,
                            }}>
                            {formatMoveEval(gameMoves?.[index])}
                          </CCText>
                        </Box>
                      </Box>
                      <Box
                        flex={0.46}
                        style={[
                          isBlackMoveSelected
                            ? customStyles?.selectedMove
                            : index === 0 ||
                              (playerOneColor === playerTwoColor && index === 1)
                            ? customStyles.eachMoveWrapper2
                            : customStyles.eachMoveWrapper,
                          {
                            height: '100%',
                          },
                        ]}>
                        <Box
                          flexDirection="row"
                          justifyContent="flex-start"
                          // flexDirection="row"
                          style={customStyles.eachMoveInsideWrapper}
                          alignItems="center"
                          onPress={() => handleMoveSelect(index + 1)}
                          // onPress={() => {
                          //   if (!gameMoves?.[index + 1]) return;
                          //   setIndexSelected(index + 1);
                          //   if (isBlackMoveSelected) {
                          //     handleAddAnnotation(gameMoves?.[index + 1]);
                          //   }
                          //   handleChessMove(
                          //     gameMoves?.[index + 1],
                          //     false,
                          //     '',
                          //     gameMoves?.[index],
                          //   );
                          //   if (main) {
                          //     console.log(gameMoves[index]);
                          //     setmoveSelected(gameMoves[index]);
                          //   } else {
                          //     console.log(gameMoves[index + 1]);
                          //     setmoveSelected(gameMoves[index + 1]);
                          //   }

                          //   setClicked?.(true);
                          //   setIsFenFromOutside(false);
                          // }}
                          flex={1}
                          style={{width: '100%'}}>
                          {isBlackMoveSelected && (
                            <ConditionalRender
                              condition={useFeather}
                              childrenA={
                                <>
                                  <Feather
                                    size={20}
                                    name="edit-3"
                                    color={CCColors.Primary.Brown}
                                    onPress={event => {
                                      handleAddAnnotation(
                                        gameMoves?.[index + 1],
                                      );
                                      event.stopPropagation();
                                    }}
                                  />
                                  <Spacer spacing={5} horizontal />
                                </>
                              }
                            />
                          )}
                          <CCText
                            style={[
                              // activeMove?.fen ===
                              // gameMoves?.[index + 1]?.fen
                              //   ? customStyles?.selectedMove
                              //   : customStyles?.playerScoreEach,
                              {
                                width: '100%',
                                textAlign: 'left',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                // marginVertical: 15,
                                flex: 0.5,
                              },
                            ]}>
                            {gameMoves?.[index + 1]?.move}{' '}
                            {
                              moveIconsAndColors?.[
                                evaluateMove(gameMoves?.[index + 1])
                              ]?.icon
                            }
                            {renderOpeningPrincipleIcons(
                              gameMoves?.[index + 1],
                            )}
                          </CCText>{' '}
                          {gameMoves?.[index + 1]?.annotation_icon && (
                            <Box style={customStyles?.annotationIconsWrapper}>
                              <Image
                                resizeMode="contain"
                                style={[customStyles.annotationIcons]}
                                source={
                                  moveAnnotationsObjToDisplay[
                                    gameMoves?.[index + 1]?.annotation_icon
                                  ]?.icon
                                }
                              />
                            </Box>
                          )}
                          {/* {gameMoves?.[index + 1]?.annotation && (
                        <CCText
                          style={{
                            position: 'absolute',
                            right: 0,
                            top: 0,
                            backgroundColor: updateColorWithOpacity(
                              CCColors?.Red,
                              0.7,
                            ),
                            borderBottomLeftRadius: 5,
                            borderBottomRightRadius: 5,
                            padding: 2,
                            color: CCColors.White,
                          }}>
                          note
                        </CCText>
                      )} */}
                          <CCText
                            style={{
                              textAlign: 'center',
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginVertical: 15,
                              fontSize: FontSizes[10],
                              color: CCColors.TextColor.Grey,
                              flex: 0.5,
                            }}>
                            {formatMoveClock(gameMoves?.[index + 1])}
                          </CCText>
                          <CCText
                            style={{
                              textAlign: 'right',
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginVertical: 15,
                              fontSize: FontSizes[10],
                              color: CCColors.TextColor.Grey,
                              flex: 0.5,
                            }}>
                            {formatMoveEval(gameMoves?.[index + 1])}
                          </CCText>
                        </Box>
                      </Box>
                    </Box>
                    <Box marginLeft={'15%'}>
                      <CCText
                        color={CCColors?.Grey.Grey}
                        fontSize={FontSizes[11]}>
                        {gameMoves?.[index]?.annotation &&
                          `${gameMoves?.[index]?.annotation} (${gameMoves?.[index]?.move})`}
                      </CCText>
                      <CCText
                        color={CCColors?.Grey.Grey}
                        fontSize={FontSizes[11]}>
                        {gameMoves?.[index + 1]?.annotation &&
                          `${gameMoves?.[index + 1]?.annotation} (${
                            gameMoves?.[index + 1]?.move
                          })`}
                      </CCText>

                      {gameMoves?.[index]?.child_moves?.length > 0 &&
                        displayChildMove(
                          gameMoves?.[index],
                          '',
                          0,
                          1,
                          null,
                          (currMove, lastMove) => {
                            handleChessMove(currMove, false, '', lastMove);

                            setmoveSelected?.({
                              ...currMove,
                              newFen: currMove?.fen,
                              lastFen: lastMove?.fen,
                              move: currMove?.san,
                            });
                            setIsFenFromOutside(false);
                          },
                          Math.floor(index / 2 + 1),
                        )}
                      {gameMoves?.[index + 1]?.child_moves?.length > 0 &&
                        displayChildMove(
                          gameMoves?.[index + 1],
                          '',
                          0,
                          1,
                          null,
                          (currMove, lastMove) => {
                            handleChessMove(currMove, false, '', lastMove);

                            setmoveSelected?.({
                              ...currMove,
                              newFen: currMove?.fen,
                              lastFen: lastMove?.fen,
                              move: currMove?.san,
                            });

                            setIsFenFromOutside(false);
                          },
                          Math.floor(index / 2 + 1),
                        )}
                    </Box>
                    {/* {(gameMoves?.[index + 1]?.annotation ||
                gameMoves?.[index]?.annotation) && (
                <>
                  <Spacer spacing={10} />
                  <CCText>Notes</CCText>
                  {gameMoves?.[index]?.annotation}
                  {gameMoves?.[index + 1]?.annotation}
                </>
              )} */}
                  </>,
                );
              }
              return returnDiv;
              // }
            } else {
              return null;
            }
          })}
        </ScrollView>
      )}
    </View>
  );
};

export default React.memo(MovesList);
